import { CheckCircleIcon, FileAddedIcon, PencilIcon } from '@primer/octicons-react';
import { graphql, useFragment } from 'react-relay';

import { FormulaSetHistoryTimelineItem_formulaSetHistory$key } from '../../../relay/__generated__/FormulaSetHistoryTimelineItem_formulaSetHistory.graphql';
import DateText from '../../core/DateText';
import EnumPair from '../../core/EnumPair';
import Grid from '../../core/Grid';
import Label from '../../core/Label';
import Timeline from '../../core/Timeline';
import View from '../../core/View';
import UserAvatarText from '../../user/UserAvatarText';

const FormulaSetHistoryTimelineItem_formulaSetHistory = graphql`
  fragment FormulaSetHistoryTimelineItem_formulaSetHistory on FormulaSetHistory {
    id
    createdBy {
      ...UserAvatarText_user
    }
    created
    type
  }
`;

type Props = { formulaSetHistory: FormulaSetHistoryTimelineItem_formulaSetHistory$key };

const FormulaSetHistoryTimelineItem = ({ formulaSetHistory }: Props) => {
  const { created, createdBy, type } = useFragment(FormulaSetHistoryTimelineItem_formulaSetHistory, formulaSetHistory);
  return (
    <Timeline.Item>
      <Timeline.Badge>
        {type === 'formula_set_create' ? (
          <FileAddedIcon />
        ) : type === 'formula_set_update' ? (
          <PencilIcon />
        ) : type === 'formula_set_review' ? (
          <CheckCircleIcon />
        ) : null}
      </Timeline.Badge>
      <Timeline.Body>
        <Grid sx={{ alignItems: 'center' }}>
          <Grid.Unit size={'max'}>
            <Grid.Unit size={'max'}>
              <View sx={{ display: 'flex', flexDirection: 'column' }}>
                <UserAvatarText user={createdBy} sx={{ fontWeight: 'bold', color: 'fg.muted' }} />
                <View sx={{ marginTop: 2 }}>
                  <DateText sx={{ fontSize: 0, color: 'fg.subtle' }}>{created}</DateText>
                </View>
              </View>
            </Grid.Unit>
          </Grid.Unit>
          <Grid.Unit size={'min'}>
            <Label
              variant={
                type === 'formula_set_create'
                  ? 'default'
                  : type === 'formula_set_update'
                  ? 'accent'
                  : type === 'formula_set_review'
                  ? 'success'
                  : 'default'
              }
            >
              <EnumPair typename={'FormulaSetHistoryTypeEnum'}>{type}</EnumPair>
            </Label>
          </Grid.Unit>
        </Grid>
      </Timeline.Body>
    </Timeline.Item>
  );
};

export default FormulaSetHistoryTimelineItem;
